import { Link } from "@chakra-ui/react";

const types = {
  text: "string",
  number: "number",
  object: "object",
};

interface DataTypeInfoProps {
  type: string;
}

export const DataTypeInfo = (props: DataTypeInfoProps) => {
  return (
    <Link target="_blank" textDecoration="underline dashed">
      {types[props.type as keyof typeof types]}
    </Link>
  );
};
